import {useDispatch, useSelector} from "react-redux";

export const PAGES = {
    OUTPUT_FORMS: 'Выходные формы',
    TEMPLATES: 'Шаблоны материалов наблюдений',
    ARCHIVE: 'Архив материалов наблюдений',
    CONSTRUCTORS: 'Конструкторы',
    CALCULATIONS: 'Расчеты'
}


//МЕТОД В КОТОРОМ БУДЕТ РАСПОЛАГАТЬСЯ ЛОГИКА ВЫТАСКИВАНИЯ ПРИВЕЛЕГИЙ ИЗ СТЕЙТА ДЛЯ КОНКРЕТНОЙ СТРАНИЦЫ
export function getPrivilegesForPage(page, privileges) {
    let curPrivilege = {canRead: false, canWrite: false, canAdmin: false};
    privileges.filter(el => {
        return el.privilege.shortName === page
    }).forEach((el) => {
        if (el.right === "ADMIN" && !curPrivilege.canAdmin) {
            curPrivilege = {canRead: true, canWrite: true, canAdmin: true};
            return
        }
        if (el.right === "WRITE" && !curPrivilege.canWrite) {
            curPrivilege = {canRead: true, canWrite: true, canAdmin: curPrivilege.canAdmin};
            return;
        }
        if (el.right === "READ" && !curPrivilege.canRead) {
            curPrivilege = {canRead: true, canWrite: curPrivilege.canWrite, canAdmin: curPrivilege.canAdmin};
        }
    })

    return curPrivilege
}

export function getArchiveElementsRights(privileges) {
    const privilege = getPrivilegesForPage("ARCHIVE", privileges)

    return {
        canDownload: privilege.canRead,
        canFormReport: privilege.canRead,
        canUpload: privilege.canWrite,
        canUploadNewVersion: privilege.canWrite,
        canRemove: privilege.canAdmin
    }
}

export function getOutputFormRights(privileges) {
    const privilege = getPrivilegesForPage("OUTPUT_FORMS", privileges)

    return {
        canDownload: privilege.canRead,
        canRemove: privilege.canAdmin
    }
}

export function getTemplatesRights(privileges) {
    const privilege = getPrivilegesForPage("TEMPLATES", privileges)

    return {
        canShowInDetails: privilege.canWrite,
        canCreateOutputForm: privilege.canWrite,
        canRemove: privilege.canAdmin
    }
}
export function canSeeMaterials(privileges) {
    const constructors = getPrivilegesForPage("CONSTRUCTORS", privileges)
    const archive = getPrivilegesForPage("ARCHIVE", privileges)
    const of = getPrivilegesForPage("OUTPUT_FORMS", privileges)
    const templates = getPrivilegesForPage("TEMPLATES", privileges)

    return constructors.canRead || archive.canRead || of.canRead || templates.canRead;
}
export function getDecadeConstructorRights(privileges) {
    const privilege = getPrivilegesForPage("CONSTRUCTORS", privileges)

    return getConstructorRights(privilege)
}

export function getTTConstructorRights(privileges) {
    const privilege = getPrivilegesForPage("CONSTRUCTORS", privileges)

    return getConstructorRights(privilege)
}

export function getRainFloodConstructorRights(privileges) {
    const privilege = getPrivilegesForPage("CONSTRUCTORS", privileges)

    return getConstructorRights(privilege)
}

export function getRiverFloodConstructorRights(privileges) {
    const privilege = getPrivilegesForPage("CONSTRUCTORS", privileges)

    return getConstructorRights(privilege)
}

function getConstructorRights(privilege) {
    return {
        canCreateOutputForm: privilege.canWrite,
        canSaveTemplate: privilege.canWrite,
    }
}

//МЕТОД В КОТОРОМ БУДЕТ РАСПОЛАГАТЬСЯ ЛОГИКА ВЫТАСКИВАНИЯ ВИДИМОСТИ СТРАНИЦ ИЗ СТЕЙТА
export function getPagesVisibility(privileges) {
    const availablePages = privileges.map((el) => el.privilege.shortName)

    return {
        OUTPUT_FORMS: availablePages.includes("OUTPUT_FORMS"),
        TEMPLATES: availablePages.includes("TEMPLATES"),
        ARCHIVE: availablePages.includes("ARCHIVE"),
        CONSTRUCTORS: availablePages.includes("CONSTRUCTORS")
        // DECADE_CONSTRUCTOR: availablePages.includes("CONSTRUCTORS"),
        // TT_CONSTRUCTOR: availablePages.includes("CONSTRUCTORS"),
        // RAIN_FLOOD_CONSTRUCTOR: availablePages.includes("CONSTRUCTORS"),
        // RIVER_FLOOD_CONSTRUCTOR: availablePages.includes("CONSTRUCTORS")
    }
}